import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastService } from './core/toast';
import { ConfirmDialog } from './shared/confirm-dialog/confirm-dialog';
import { Icon } from './shared/icon/icon';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ConfirmDialog, Icon],
  template: `
    <router-outlet />

    <div class="toast-host">
      @for (t of toast.toasts(); track t.id) {
        <div
          class="toast"
          [class.ok]="t.kind === 'ok'"
          [class.err]="t.kind === 'err'"
          [attr.role]="t.kind === 'err' ? 'alert' : 'status'"
          title="Clic para cerrar"
          (click)="toast.dismiss(t.id)"
        >
          <span class="toast-icon">
            <app-icon [name]="t.kind === 'err' ? 'x' : 'check'" [size]="15" [stroke]="2.5" />
          </span>
          <span>{{ t.message }}</span>
        </div>
      }
    </div>

    <app-confirm-dialog />
  `,
})
export class App {
  protected readonly toast = inject(ToastService);
}
